__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "axiomPrice";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@j-t-mcc/vue3-chartjs", "1.3.0", function() { return __webpack_require__.e(178).then(function() { return function() { return __webpack_require__(1797); }; }); });
			register("@microsoft/signalr", "6.0.11", function() { return __webpack_require__.e(83).then(function() { return function() { return __webpack_require__(464); }; }); });
			register("@popperjs/core", "2.11.6", function() { return __webpack_require__.e(333).then(function() { return function() { return __webpack_require__(4333); }; }); });
			register("bootstrap", "5.2.3", function() { return __webpack_require__.e(197).then(function() { return function() { return __webpack_require__(4578); }; }); });
			register("chart.js", "3.9.1", function() { return __webpack_require__.e(363).then(function() { return function() { return __webpack_require__(7363); }; }); });
			register("date-fns", "2.29.3", function() { return __webpack_require__.e(517).then(function() { return function() { return __webpack_require__(9517); }; }); });
			register("diacriticless", "1.0.1", function() { return __webpack_require__.e(758).then(function() { return function() { return __webpack_require__(5758); }; }); });
			register("html2pdf.js", "0.10.3", function() { return __webpack_require__.e(947).then(function() { return function() { return __webpack_require__(9947); }; }); });
			register("lodash.groupby", "4.6.0", function() { return __webpack_require__.e(196).then(function() { return function() { return __webpack_require__(9815); }; }); });
			register("lodash.isequal", "4.5.0", function() { return __webpack_require__.e(29).then(function() { return function() { return __webpack_require__(1029); }; }); });
			register("lodash.merge", "4.6.2", function() { return __webpack_require__.e(25).then(function() { return function() { return __webpack_require__(25); }; }); });
			register("lodash.sortby", "4.7.0", function() { return __webpack_require__.e(757).then(function() { return function() { return __webpack_require__(7138); }; }); });
			register("vue-router", "4.1.6", function() { return __webpack_require__.e(768).then(function() { return function() { return __webpack_require__(1387); }; }); });
			register("vue", "3.2.45", function() { return __webpack_require__.e(796).then(function() { return function() { return __webpack_require__(5796); }; }); });
			register("vuex", "4.1.0", function() { return __webpack_require__.e(401).then(function() { return function() { return __webpack_require__(782); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};